<template>
  <v-dialog
    v-model="dialog"
    width="50%"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-card>
      <v-card-title class="headline">Phone Verification</v-card-title>
      <v-card-text>

        <div>
          <v-alert type="success" v-show="requestSent">
            Verification code was sent to your phone number. Please check and
            submit verification code here to confirm.
          </v-alert>
        </div>

        <v-row>
          <v-col cols="12">
            If you have verification code, you can enter here and click verify
            button.
            <v-text-field
              v-model="form.code"
              placeholder="Enter verification code here"
              type="number"
              :error-messages="[].concat(fieldErrors('form.code'))"
              :blur="$v.form.code.$touch()"
            >
              <template v-slot:append>
                <v-btn
                  v-if="!requestSent"
                  @click="requestCode()"
                  :disabled="isRequesting"
                  :loading="isRequesting"
                  text
                  x-small
                  >Request Code</v-btn
                >
              </template>
            </v-text-field>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-btn
          color="info"
          @click="confirmCode()"
          :loading="isConfirming"
          :disabled="$v.$invalid"
          >Verify</v-btn
        >
        <v-spacer></v-spacer>

        <v-btn @click="closeDelete">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import formatterMixin from "@/mixins/formatterMixin";
import { required } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
import { mapState } from "vuex";

export default {
  components: {
  },
  mixins: [formatterMixin, validationMixin],
  props: {
    item: [Object, String],
    show: [Boolean, String],
  },

  validations: {
    form: {
      code: { required },
    },
  },
  validationMessages: {
    form: {
      code: { required: "Required" },
    },
  },

  data() {
    return {
      dialog: false,
      namespace: "Invoices",
      page: "Invoices",

      form: {
        code: "",
      },

      codeSent: false,
      isRequesting: false,
      isConfirming: false,
      isConfirmed: false,

      tableOptions: {},
      clients: [],
    };
  },

  computed: {
    ...mapState({
      status: (state) => state.account.status
    }),

    requestSent() {
      return this.codeSent && !this.status.error;
    }
  },
  watch: {
    async dialog(n) {
      if (!n) {
        this.closeDelete();
      }
    },
    show(n, o) {
      if (n && !o) {
        this.dialog = true;
      }
    },
  },

  methods: {
    async requestCode() {
      this.isRequesting = true;
      try {
        await this.$store.dispatch("account/requestPhoneVerification");
        this.codeSent = true;
      } catch (e) {
        this.codeSent = false;
      }
      this.isRequesting = false;
    },

    async confirmCode() {
      this.isConfirming = true;
      await this.$store.dispatch("account/verifyPhone", this.form.code);
      if (!this.status.error) {
        this.isConfirmed = true;
        await this.$store.dispatch("account/reloadAccount", this.form.code);
        this.closeDelete();
      }
      this.isConfirming = false;            
    },

    closeDelete() {
      this.dialog = false;
      this.$emit("onClosed");      
    },
  },
};
</script>